import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { formatNumber, parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Enums for level and category
const levelEnum: Record<number, string> = {
  0: "Read Only",
  1: "Read Write",
  2: "Admin",
};

const categoryEnum: Record<number, string> = {
  0: "User",
  1: "Admin",
  2: "System",
};

// Type of the fields in the table

export type Permission = {
  id: number;
  user_id?: number;
  user_email?: string;
  user_name?: string;
  created_at: string;
  updated_at: string;
  status?: number;
  strategy_id?: number;
  level?: number;
  category?: number;
  type?: string;
  max_issuer_count?: number;
  admin_user_id?: number;
};

// Definition of the columns

export const permissions_columns: ColumnDef<Permission>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "user_id",
    header: "User",
    cell: ({ row }) => {
      const userId = row.getValue("user_id");
      const userName = row.original.user_name;

      if (userName) {
        if (userId !== null && userId !== undefined) {
          return (
            <Link
              href={toWorkspacePath(`/admin/legacy-quantilia/users/${userId}`)}
              className="text-xs"
              underline="hover"
            >
              {userName}
            </Link>
          );
        }
        return userName;
      } else if (userId !== null && userId !== undefined) {
        return (
          <Link
            href={toWorkspacePath(`/admin/legacy-quantilia/users/${userId}`)}
            className="text-xs"
            underline="hover"
          >
            {String(userId)}
          </Link>
        );
      }
      return "";
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue("created_at")),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDate(row.getValue("updated_at")),
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const value = row.getValue("status");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    accessorKey: "strategy_id",
    header: "Strategy",
    cell: ({ row }) => {
      const value = row.getValue("strategy_id");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    accessorKey: "level",
    header: "Level",
    cell: ({ row }) => {
      const value = row.getValue("level") as number;
      return value !== null && value !== undefined
        ? levelEnum[value] || value
        : "";
    },
  },
  {
    accessorKey: "category",
    header: "Category",
    cell: ({ row }) => {
      const value = row.getValue("category") as number;
      return value !== null && value !== undefined
        ? categoryEnum[value] || value
        : "";
    },
  },
  {
    accessorKey: "type",
    header: "Type",
    cell: ({ row }) => {
      const value = row.getValue("type");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    accessorKey: "max_issuer_count",
    header: () => <div className="text-right">Max Issuer Count</div>,
    cell: ({ row }) => {
      const value = row.getValue("max_issuer_count");
      return (
        <div className="text-right">
          {value !== null && value !== undefined
            ? formatNumber(value as number)
            : ""}
        </div>
      );
    },
  },
  {
    accessorKey: "admin_user_id",
    header: "Administrator",
    cell: ({ row }) => {
      const adminId = row.getValue("admin_user_id");

      if (adminId !== null && adminId !== undefined) {
        return (
          <Link
            href={toWorkspacePath(
              `/admin/legacy-quantilia/admin-users/${adminId}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {String(adminId)}
          </Link>
        );
      }
      return "";
    },
  },
];
